<div class="content-body default-height">
    <!-- Breadcrumb  -->
    <app-breadcrumb [breadcrumb]="breadcrumbList" [addProperty]="'Back'" (addEvent)="inspectionEvent($event)">
    </app-breadcrumb>
    <div class="container-fluid">
        <div class="card">
            <div class="p-2 mt-1 ms-2">
                <div class="row mb-2" *ngIf="checkInspectionAddRoom">
                    <div class="col-md-6">                    
                        <p class="float-start"><span class="property-name">Property Name :</span> {{ inspectionDetails?.property_name }}</p>
                    </div>
                    <div class="col-md-6">                        
                        <button class="btn btn-primary btn-sm me-2 float-end" type="button" (click)="showHideRoom()">Add Room</button>                    
                    </div>
                </div>
                <form [formGroup]="editRoomItemsForm" (ngSubmit)="saveRoomItems()">
                    <div ngbAccordion class="{{ maneClass }}" *ngFor="let room of editrooms.controls; let i = index"
                        formArrayName="editrooms" id="room-{{ i }}">
                        <div ngbAccordionItem #item="ngbAccordionItem" [collapsed]="true" class="item"
                            [formGroupName]="i">
                            <h2 ngbAccordionHeader [ngClass]="{'accordion-header accordion-header-primary': bg}"
                                class="room-inspections">
                                <button ngbAccordionButton class="accordion-header rounded-lg">
                                    {{ room.get('room_name')?.value }}
                                </button>
                            </h2>
                            <div ngbAccordionCollapse>
                                <div ngbAccordionBody>
                                    <ng-template>
                                        <div class="row">
                                            <div class="col-xl-12">
                                                <button type="button" *ngIf="checkInspectionDeleteRoom"
                                                    class="btn btn-danger shadow btn-xs sharp me-2 float-end"
                                                    (click)="deletePropertyRoom(room.get('id')?.value)">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                                <button type="button" *ngIf="checkInspectionAddRoomItems"
                                                    class="btn btn-success shadow btn-xs sharp me-2 float-end"
                                                    (click)="showHideEditRoom(room.get('id')?.value, room.get('room_name')?.value)">
                                                    <i class="fa fa-edit"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <!-- Regular table for desktop view -->
                                        <div class="table-responsive d-none d-md-block mt-2">
                                            <table class="table mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Items</th>
                                                        <th>Quantity</th>
                                                        <th>Condition</th>
                                                        <th class="text-center">Notes</th>
                                                        <th class="text-center w-30">Images</th>
                                                    </tr>
                                                </thead>
                                                <tbody formArrayName="items">
                                                    <tr *ngFor="let item of getItems(i).controls; let j = index"
                                                        [formGroupName]="j">
                                                        <td>{{ item.get('item_name')?.value }}</td>
                                                        <td class="width110"><input type="number" class="form-control"
                                                                formControlName="item_quantity" placeholder="Quantity" (change)="updateInspectionNotes(room.get('id')?.value, item.get('id')?.value, item.get('item_quantity')?.value, item, 'item_quantity')"/>
                                                        </td>
                                                        <td>
                                                            <select class="form-control"
                                                                formControlName="item_condition" (change)="updateInspectionCondition(room.get('id')?.value, item.get('id')?.value, 'item_condition',  item.get('item_condition')?.value, item)">
                                                                <option value="" selected disabled>Select</option>
                                                                <option *ngFor="let status of defaultInspectionStatus" [value]="status"> {{status}}</option>
                                                                
                                                            </select>
                                                        </td>
                                                        <td><input type="text" class="form-control"
                                                                formControlName="item_notes" placeholder="Notes" (change)="updateInspectionNotes(room.get('id')?.value, item.get('id')?.value, item.get('item_notes')?.value, item, 'item_notes')"/>
                                                        </td>
                                                        <td>
                                                            <div class="d-flex gap-1">
                                                                <input type="file" class="form-control" multiple  (change)="uploadImages($event, room.get('id')?.value, item.get('id')?.value, item)" accept="image/*"/>
                                                                <div class="col-md-1">
                                                                    <i class="fa fa-eye mt-3 c-pointer" *ngIf="item.get('item_uploads')?.value?.length" (click)="viewPropertyImage(viewImagecontent, item.get('item_uploads')?.value, item)"></i>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        <!-- Vertical card-style layout for mobile view -->
                                        <div class="d-block d-md-none" formArrayName="items">
                                            <div class="card mb-2 p-2"
                                                *ngFor="let item of getItems(i).controls; let j = index"
                                                [formGroupName]="j">
                                                <div><strong>Items:</strong> {{ item.get('item_name')?.value }}</div>
                                                <div class="mt-1">
                                                    <strong>Quantity:</strong>
                                                    <input type="number" class="form-control mt-1"
                                                        formControlName="item_quantity" (change)="updateInspectionNotes(room.get('id')?.value, item.get('id')?.value, item.get('item_quantity')?.value, item, 'item_quantity')"/>
                                                </div>
                                                <div class="mt-1">
                                                    <strong>Condition:</strong>
                                                    <select class="form-control mt-1" formControlName="item_condition" (change)="updateInspectionCondition(room.get('id')?.value,item.get('id')?.value, 'item_condition' , item.get('item_condition')?.value, item)">
                                                        <option value="" selected disabled>Select</option>
                                                        <option *ngFor="let status of defaultInspectionStatus" [value]="status"> {{status}}</option>
                                                    </select>
                                                </div>
                                                <div class="mt-1">
                                                    <strong>Notes:</strong>
                                                    <input type="text" class="form-control mt-1"
                                                        formControlName="item_notes" (blur)="updateInspectionNotes(room.get('id')?.value, item.get('id')?.value, item.get('item_notes')?.value, item, 'item_notes')"/>
                                                </div>
                                                <div class="mt-2">
                                                    <strong>Images:</strong>
                                                    <div class="d-flex gap-1 mt-1">
                                                        <input type="file" class="form-control" multiple  (change)="uploadImages($event, room.get('id')?.value, item.get('id')?.value, item)" accept="image/*"/>
                                                        <i class="fa fa-eye mt-3 c-pointer" *ngIf="item.get('item_uploads')?.value?.length" (click)="viewPropertyImage(viewImagecontent, item.get('item_uploads')?.value, item)"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                    </ng-template>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <form [formGroup]="editInspectionForm" (ngSubmit)="onSubmit()" autocomplete="off">
                    <div class="row">
                        <div class="col-xl-12 mb-3">
                            <label for="exampleFormControlInput1-4" class="form-label">Notes</label>
                            <textarea type="text" class="form-control" id="exampleFormControlInput1-3" placeholder="Notes"
                                formControlName="inspection_notes"></textarea>
                        </div>
                        <!-- <div class="col-xl-6 mb-3">
                            <label for="exampleFormControlInput1-2" class="form-label">Inspection Status</label>
                            <select class="form-select" formControlName="inspection_status">
                                <option data-display="Select" value="null" selected>Select Status</option>
                                <option value="In Progress">In Progress</option>
                                <option value="Submitted">Submitted</option>
                                <option value="Owner Review">Owner Review</option>
                                <option value="Tenant Review">Tenant Review</option>
                                <option value="Completed">Completed</option>
                            </select>
                        </div> -->
                    </div>
                    <div>
                  <button class="btn btn-primary ms-1 me-3 float-end" type="submit" [disabled]="loadingService.isLoading()">Submit</button>
              </div>
                </form>
            </div>
        </div>
    </div>
</div>
<ng-template #viewImagecontent let-modal>
    <div class="modal-header">
        <h5 class="modal-title"> Inspection Images </h5>
        <button type="button" class="btn-close" (click)="closeModal()"></button>
    </div>
    <div class="modal-body">
        <ngb-carousel class="fixed-height-carousel" [showNavigationIndicators]="false">

            <ng-template ngbSlide *ngFor="let image of inspectionImages">
                <div class="picsum-img-wrapper position-relative">
                    <img [src]="image.url" alt="" class="d-block w-100" />
                    <button type="button" class="img-delete-btn" title="Delete image"
                            aria-label="Delete image" (click)="deleteInspectionImage(image?.id)">
                        <i class="fa fa-trash"></i>
                    </button>
                    <div class="gps-overlay" *ngIf="checkLocationView && image?.latitude && image?.longitude">
                        <div class="gps-overlay__map">
                            <img *ngIf="image.map_image_url" [src]="image.map_image_url" alt="Satellite location" />
                            <span class="gps-overlay__pin"></span>
                        </div>
                        <div class="gps-overlay__info">
                            <div class="gps-overlay__address" *ngIf="image.address">{{ image.address }}</div>
                            <div class="gps-overlay__line">Lat: {{ image.latitude }}&nbsp;&nbsp;Long: {{ image.longitude }}</div>
                            <div class="gps-overlay__line" *ngIf="image.captured_at">{{ image.captured_at | date:'dd/MM/yyyy hh:mm a' }}</div>
                        </div>
                    </div>
                </div>
            </ng-template>

        </ngb-carousel>
    </div>
    <div class="modal-footer">
        <!-- <button type="button" class="btn btn-secondary" (click)="prevImage(selectedImage.index)" [disabled]="selectedImage.prevImageDisable">Prev</button> -->
        <button type="button" class="btn btn-secondary" (click)="closeModal()">Close</button>
    </div>
</ng-template>
<div #addEditRoom class="offcanvas offcanvas-end customeoff {{ add_room ? 'show':''}}" tabindex="-1" id="add_room"
    data-bs-backdrop="static" >
    <div class="offcanvas-header">
        <h5 class="modal-title" id="#gridSystemModal">{{ isRoomEdit ? 'Edit' : 'Add'}} Room</h5>
        <button type="button" class="btn-close" (click)="addRoomClose()">
            <i class="fa-solid fa-xmark"></i>
        </button>
    </div>
    <div class="offcanvas-body">
        <div class="container-fluid">
            <form [formGroup]="roomsForm" (ngSubmit)="saveRoom()" autocomplete="off" *ngIf="roomsForm">

                <div class="row">
                    <div class="col-xl-12 mb-3">
                        <label for="exampleFormControlInput1-1" class="form-label">Room Name<span
                                class="text-danger">*</span></label>
                        <input type="text" class="form-control" id="exampleFormControlInput1-1" placeholder="Room name"
                            formControlName="room_name">
                        <div *ngIf="roomsForm?.get('room_name')?.invalid && roomsForm?.get('room_name')?.touched"
                            class="required">
                            Room Name is required
                        </div>
                    </div>
                    <div class="col-xl-12 mb-3">
                        <label class="form-label">Search Room Items</label>
                        <input type="text" class="form-control" placeholder="Search for room items"
                            formControlName="searchText" (input)="filterItems()" autocomplete="off">
                    </div>
                    <div class="col-xl-12 mb-3">
                        <label class="form-label mb-3">Select Room Items</label>
                        <div class="row" formArrayName="selectedItems">
                            <div class="col-12 col-sm-6 col-md-4 col-lg-3"
                                *ngFor="let permission of filteredItems; let i= index">
                                <div class="form-check custom-checkbox mb-2">
                                    <input type="checkbox" class="form-check-input" [id]="permission.id"
                                        [formControlName]="i">
                                    <label class="form-check-label" [for]="permission.id">{{permission.name}}</label>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="roomsForm?.get('selectedItems')?.invalid && roomsForm?.get('selectedItems')?.touched"
                            class="required">
                            At least one checkbox must be selected.
                        </div>
                    </div>

                </div>

                <div>
                    <button class="btn btn-primary ms-1 me-3" type="submit"
                        [disabled]="roomsForm.invalid || loadingService.isLoading()">Submit</button>
                    <button class="btn btn-danger lightme-1" type="button" (click)="addRoomClose()">Cancel</button>
                </div>
            </form>
        </div>
    </div>
</div>
@if(add_room){
<div class="offcanvas-backdrop fade show" (click)="showHideRoom()"></div>
}